/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![PremiumChannelIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABY0lEQVR4nNWVyUrEQBCGM+pbuAuC+BK5m9SSSFOV8e42b6CHnNTxaVzBi4ogvok66NUFbyMdEp1BJmMyNGhBHTo09f2d2jzvL5nv+xPWnQGQZRdZU2cAYDkBknOXgAckfXYSPIrWppC1az0MzczIAZHlCCNtpWk6Zs8hJfwFoGQ1v9YAli0kPa4MAJZ1GwxY78I4WUKS/QKArO0gbi4gyVV+3qzziAawXmcQ0ndkvS8ANhf5ty6S3Ni7dQAekcwB6UuP8j63kCBOFuslFDUC0oNe5T8AtqpY2zYnpYk3xozbJsrr/HFQQBziQPJk+ySkZNsJAEk7wHI6NOm//kWUiWkDS0wk05VzAWDmkeW1RPUHoln2alppmSLrW16mt0UzVjKiZKOv0Vj3vpXLYdZorJfZOdJWZQCSng0aFRiJKV6ZCSG58Ea1IDCTBWAlbs56/25cW7NT0+3CIdlxujKdL/069glKXSqHoL3M0AAAAABJRU5ErkJggg==)
 */
export const PremiumChannelIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="m21.5 11.5-5.9-1.22 2.24-3.44a.5.5 0 0 0-.68-.68L13.72 8.4 12.5 2.5a.5.5 0 1 0-.98 0l-1.23 5.9-3.44-2.24a.5.5 0 0 0-.68.68l2.24 3.44-5.9 1.23a.5.5 0 1 0 0 .98l5.9 1.23-2.24 3.44a.48.48 0 0 0 .07.6.46.46 0 0 0 .35.16c.1 0 .18-.03.26-.08l3.44-2.24 1.23 5.9a.5.5 0 1 0 .98 0l1.23-5.9 3.44 2.24c.08.05.17.07.26.08a.46.46 0 0 0 .35-.15.48.48 0 0 0 .07-.61l-2.24-3.44 5.9-1.23a.5.5 0 0 0 0-.98Z"
        className={colorClass}
      />
    </svg>
  );
};
